export enum RetailMatchIndexColor {
  black = "#000000",
  lightGreen = "#66d69c",
  green = "#2fb26e",
  red = "#ff5154",
  yellow = "#efbf55",
}
